<template>
  <div class="home">
    <FilterLayout v-model="searchForm" @onSubmit="onSubmit">
      <el-col :md="12" :lg="6" :sm="24">
        <el-form-item label="时间" prop="time">
          <!-- <el-date-picker
            v-model="searchForm.time"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            :clearable="false"
            :append-to-body="false"
            unlink-panels
          /> -->
          <dataPicker :datevalue.sync="searchForm.time" :shortcutsT1Flag="true"></dataPicker>
        </el-form-item>
      </el-col>
      <el-col :md="12" :lg="7" :sm="24">
        <el-form-item label="渠道" prop="channel" style="max-height: 50px">
          <SelectChannel v-model="searchForm.channel"></SelectChannel>
        </el-form-item>
      </el-col>
      <!-- <el-col :md="12" :lg="5" :sm="24">
        <el-form-item label="时间刻度" prop="timeType">
          <el-radio-group v-model="searchForm.timeType">
            <el-radio-button v-for="(v, i) in timeTypeConfig" :key="i" :disabled="v.disabled" :label="v.value">{{
              v.label
            }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col> -->
    </FilterLayout>
    <CountLayout :option="countData" :loading="countLoading">
      <template #cetent>
        <el-radio-group v-model="allOrinfo" @change="onAllChange" v-if="channelFlag">
          <el-radio-button :label="1">汇总走势</el-radio-button>
          <el-radio-button :label="2">明细走势</el-radio-button>
        </el-radio-group>
      </template>
      <template #option>
        <el-col :md="12" :lg="6" :sm="24">
          <el-form-item label="筛选项">
            <el-select v-model="select" placeholder="请选择筛选项" :popper-append-to-body="false" @change="onSelectChange">
              <el-option :key="i" :label="v.label" :value="v.value" v-for="(v, i) in column.slice(1)" />
            </el-select>
          </el-form-item>
        </el-col>
      </template>
      <template #extra>
        <div>平均：</div>
        <div>
          {{ (count.totalInfo && count.totalInfo.avg) | formatPercentage }}
        </div>
      </template>
    </CountLayout>
    <el-table :data="sumTable" border :show-header="false" style="width: 100%" v-loading="tableData.loading">
      <el-table-column :prop="item" v-for="item in Object.keys(sumTable[0])" :key="item"></el-table-column>
    </el-table>
    <TableLayout :column="column" :data="tableData.data" :total="tableData.total" :loading="tableData.loading"
      :currentPage="tableOpt.currentPage" :params="searchForm" :leadOut="true" @pageChange="onPageChange"
      @sizeChange="onSizeChange" :cellStyle="cellStyle"></TableLayout>
  </div>
</template>

<script>
import moment from "moment";
import _ from "lodash";
import { mapState, mapActions, mapMutations } from "vuex";
import FilterLayout from "@/layout/form";
import CountLayout from "@/layout/count";
import TableLayout from "@/layout/table";
import { pickerOptions, timeTypeOption } from "@/config/option";
import { User_Statistics_activeKeep } from "@/config/api/index";
import SelectChannel from "@/component/select-channel";

let table_arr = [];
export default {
  name: "home",
  components: {
    FilterLayout,
    TableLayout,
    CountLayout,
    SelectChannel,
  },
  data() {
    return {
      select: 2,
      searchForm: {
        time: [
          moment().subtract(30, "d").format("YYYY-MM-DD"),
          moment().subtract(2, "d").format("YYYY-MM-DD"),
        ],
        channel: [],
        timeType: 1,
      },
      tableOpt: {
        currentPage: 1,
        pageSize: 10,
      },
      pickerOptions,
      sumTable: [{}, {}],
      column: [],
      allOrinfo: 1,
      channelFlag: false,
      column: [],
      tableData: {
        data: [],
        total: 0,
        loading: false,
      },
    };
  },
  mounted() {
    this.fetchList();
    this.fetchCount();
    this.average();
  },
  computed: {
    ...mapState({
      channel: (state) => state.channel.data,
      app_version: (state) => state.app_version.data,
      count: (state) => state.active_user_keep.count.data,
      countLoading: (state) => state.active_user_keep.count.loading,
    }),
    countData() {
      const { count } = this;

      if (!count || !Object.keys(count).length) {
        return {
          legendData: [],
          xAxisData: [],
          data: [],
        };
      }

      const { date, list, listAll } = count;

      if (this.allOrinfo == 1 && this.searchForm.channel.length > 0) {
        const xAxisData = date;
        const legendData = Object.keys(listAll);
        const data = _.values(listAll);
        return {
          legendData,
          xAxisData,
          data,
          formatter: (v) => {
            if (this.select !== "0") {
              return (Number(v) * 100).toFixed(2) + "%";
            }
            return v;
          },
        };
      } else {
        const xAxisData = date;
        const legendData = Object.keys(list);
        const data = _.values(list);
        return {
          legendData,
          xAxisData,
          data,
          formatter: (v) => {
            if (this.select !== "0") {
              return (Number(v) * 100).toFixed(2) + "%";
            }
            return v;
          },
        };
      }
    },
    timeTypeConfig() {
      const { time } = this.searchForm;

      return timeTypeOption(time);
    }
  },
  methods: {
    ...mapActions(["getActiveUserKeepList", "getActiveUserKeepCount"]),
    onSubmit(res) {
      this.tableOpt.currentPage = 1;
      this.fetchList();
      this.fetchCount();
      this.average();
      if (this.searchForm.channel.length) {
        this.channelFlag = true;
      } else {
        this.channelFlag = false;
        this.vAllOrinfo = 1;
      }
    },
    onPageChange(current) {
      // arr = [];
      this.tableOpt.currentPage = current;
      this.fetchList();
    },
    onSizeChange(current) {
      this.tableOpt.pageSize = current;
      this.fetchList();
    },
    onSelectChange() {
      this.fetchCount();
    },
    async fetchList() {
      this.tableData.loading = true
      const { searchForm, tableOpt } = this;

      const [err, res] = await this.$http.post('User_Statistics/activeKeep', {
        ...searchForm,
        ...tableOpt,
        navCate: 2,
        channel: searchForm["channel"].join(","),
        timeBegin: searchForm["time"][0],
        timeEnd: searchForm["time"][1],
      });

      if (err) {
        return;
      }
      // 处理tabledata表头 ；全部是后端返回的
      let arr = [];
      for (const key in res.title) {
        let obj = {
          label: res.title[key],
          prop: key,
          // 这个value是用于展示筛选条件的值 ，根据后端返回的字段来拆分的 day1 day2
          value: key.split('y')[1] ? key.split('y')[1] * 1 : -1,
        };
        arr.push(obj);
      }
      console.log(arr, 66699)
      this.column = arr;
      // 整理table数据
      table_arr = [];
      let obj = res.list;
      obj.forEach((item, index) => {
        let i = -1;
        for (let key in item) {
          i++;
          if (key != "date" && key != "day1") {
            table_arr.push({
              column: index,
              row: i,
              count: parseFloat(item[key]),
            });
          } else {
            table_arr.push({
              column: index,
              row: i,
              count: null,
            });
          }
        }
      });

      table_arr = table_arr.map((item) => {
        if (item.count > 0 && item.count <= 19.99) {
          item.count = 0.2;
        }
        if (item.count > 19.99 && item.count <= 39.99) {
          item.count = 0.4;
        }
        if (item.count > 39.99 && item.count <= 59.99) {
          item.count = 0.6;
        }
        if (item.count > 59.99 && item.count <= 79.99) {
          item.count = 0.8;
        }
        if (item.count > 79.99 && item.count <= 99.99) {
          item.count = 1;
        }
        return {
          row: item.row,
          column: item.column,
          count: item.count,
        };
      });
      console.log(1111)
      const filterData = res.list.map((item) => {
        const obj = {};
        for (const key in item) {
          if (key != "date" && key != "day1") {
            obj[key] = parseFloat(item[key]) > 0 ? item[key] : "";
          } else {
            obj[key] = item[key];
          }
        }
        return obj;
      });

      for (const key in res.list) {
        res.list[key] = filterData[key];
      }

      this.tableData.loading = false;
      this.tableData.total = res.total;
      this.tableData.data = res.list;
    },
    async fetchCount() {
      const { searchForm, select } = this;
      const [err, res] = await this.getActiveUserKeepCount({
        ...searchForm,
        select,
        navCate: 1,
        channel: searchForm["channel"].join(","),
        timeBegin: searchForm["time"][0],
        timeEnd: searchForm["time"][1],
      });

      if (err) {
        return;
      }
    },
    average() {
      const { searchForm, select } = this;
      User_Statistics_activeKeep({
        ...searchForm,
        select,
        navCate: 6,
        channel: searchForm["channel"].join(","),
        timeBegin: searchForm["time"][0],
        timeEnd: searchForm["time"][1],
      }).then((res) => {
        if (res[2] == 1) {
          this.sumTable = [];
          this.sumTable[0] = res[1].title;
          this.sumTable[1] = res[1].avg;
        }
      });
    },
    cellStyle({ row, column, columnIndex, rowIndex }) {
      for (let i = 0; i < table_arr.length; i++) {
        let { column, row, count } = table_arr[i];
        if (columnIndex == row && rowIndex == column && count) {
          return `background: rgb(52, 127, 239, ${count})`;
        }
      }
    },
    onAllChange() {
      // this.average();
      // this.average();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-cascader__search-input {
  min-width: 10px;
}
</style>
